import ChatsSessionsList from "../components/ChatSessionsList";
import Grid from "@mui/material/Grid";
import SortByDropdown from "../components/SortByDropdown";
import SearchBar from "../components/SearchBar";
import PageSelect from "../components/PageSelect";
import MKBox from "components/MKBox";
import { Container } from "@mui/material";

function ChatsOverview() {
  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container spacing={{ xs: 0, lg: 3 }} sx={{ pt: 2, px: 2, mx: "auto" }}>
          <SortByDropdown />
          <SearchBar />
          <PageSelect />
        </Grid>
        <ChatsSessionsList />
      </Container>
    </MKBox>
  );
}

export default ChatsOverview;
